import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
import '../styles/inputBox.scss';
var InputBox = function (props) {
    var id = props.id, onChange = props.onChange, onInput = props.onInput, disabled = props.disabled, _a = props.placeholder, placeholder = _a === void 0 ? '' : _a, _b = props.value, value = _b === void 0 ? '' : _b, _c = props.ariaLabel, ariaLabel = _c === void 0 ? 'input box' : _c, ariaLabelledBy = props.ariaLabelledBy, ariaDescribedBy = props.ariaDescribedBy, ariaInvalid = props.ariaInvalid, inputMode = props.inputMode, pattern = props.pattern, _d = props.type, type = _d === void 0 ? 'text' : _d, _e = props.isNumeric, isNumeric = _e === void 0 ? false : _e, _f = props.step, step = _f === void 0 ? undefined : _f, _g = props.min, min = _g === void 0 ? undefined : _g, _h = props.max, max = _h === void 0 ? undefined : _h, maxLength = props.maxLength, _j = props.name, name = _j === void 0 ? '' : _j, _k = props.defaultCSS, defaultCSS = _k === void 0 ? '' : _k, _l = props.normalCSS, normalCSS = _l === void 0 ? '' : _l, _m = props.readOnly, readOnly = _m === void 0 ? false : _m, _o = props.autoFocus, autoFocus = _o === void 0 ? false : _o, ignoreSpecialCharacter = props.ignoreSpecialCharacter, inputControlledFromOutside = props.inputControlledFromOutside, _p = props.invalidKeys, invalidKeys = _p === void 0 ? [] : _p;
    var inputRef = useRef(null);
    var _q = useState(disabled ? 'disable' : 'normal'), inputState = _q[0], setInputState = _q[1];
    var _r = useState(value), inputValue = _r[0], setInputValue = _r[1];
    useEffect(function () {
        setInputState(disabled ? 'disable' : 'normal');
    }, [disabled]);
    useEffect(function () {
        setInputValue(value);
    }, [value]);
    useEffect(function () {
        var _a;
        if (autoFocus && inputRef.current) {
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            setInputState('active');
        }
    }, [autoFocus]);
    var minMaxUpdate = function (_val) {
        var _valueData = _val;
        if (min !== undefined && min > _val)
            _valueData = min;
        if (max !== undefined && max < _val)
            _valueData = max;
        return _valueData;
    };
    var handleFocus = function () {
        if (!disabled) {
            setInputState('active');
            onChange && onChange(id, 'focus', inputValue);
        }
    };
    var handleBlur = function (e) {
        if (!disabled) {
            setInputState('normal');
            var val = e.target.value;
            if (isNumeric) {
                var num = isNaN(Number(val)) ? 0 : Number(val);
                val = "".concat(minMaxUpdate(num));
                setInputValue(val);
                onChange && onChange(id, 'blur', val);
            }
            else if (!isNumeric) {
                onChange && onChange(id, 'blur', val);
            }
        }
    };
    var handleMouseEnter = function () {
        if (!disabled && inputState !== 'active') {
            setInputState('hover');
            onChange && onChange(id, 'mouseover', inputValue);
        }
    };
    var handleMouseLeave = function () {
        if (!disabled && inputState !== 'active') {
            setInputState('normal');
            onChange && onChange(id, 'mouseout', inputValue);
        }
    };
    var handleKeyUp = function (e) {
        if (disabled)
            return;
        if (inputState === 'active') {
            // Treat Enter as blur
            if (e.key === 'Enter') {
                e.preventDefault();
                setInputState('normal');
                onChange && onChange(id, 'keyUp', inputValue);
                e.target.blur();
            }
            // Escape: blur input but let event bubble so parent (e.g. Popup) can handle it
            if (e.key === 'Escape') {
                setInputState('normal');
                e.target.blur();
            }
        }
    };
    var handleKeyDown = function (e) {
        if (invalidKeys.includes(e.key)) {
            e.preventDefault();
        }
        // Prevent the game/board keyboard handler from intercepting keys that
        // belong to the input (cursor movement, space insertion). Without this,
        // the parent can call preventDefault on Space (blocking insertion) and
        // then starts consuming Arrow keys for board navigation.
        if (e.key === ' ' ||
            e.key === 'ArrowLeft' ||
            e.key === 'ArrowRight' ||
            e.key === 'ArrowUp' ||
            e.key === 'ArrowDown') {
            e.stopPropagation();
        }
        props.onKeyDown && props.onKeyDown(e);
    };
    var handleChange = function (e) {
        var val = e.target.value;
        if (maxLength && val.length > maxLength) {
            return;
        }
        if (ignoreSpecialCharacter && /[^a-zA-Z0-9\s]/.test(val)) {
            return;
        }
        if (!inputControlledFromOutside)
            setInputValue(val);
        onInput && onInput(id, val, e);
    };
    return (_jsx("input", { id: "".concat(id, "_input"), ref: inputRef, name: name, min: min, max: max, step: step, type: type, value: inputValue, maxLength: maxLength, placeholder: placeholder, disabled: inputState === 'disable', "aria-label": ariaLabelledBy ? undefined : ariaLabel, "aria-labelledby": ariaLabelledBy || undefined, "aria-describedby": ariaDescribedBy || undefined, "aria-invalid": ariaInvalid || undefined, "aria-disabled": inputState === 'disable', inputMode: inputMode, pattern: pattern, tabIndex: inputState !== 'disable' ? 0 : -1, className: " \n        inputStyle\n            ".concat(defaultCSS, " ").concat(normalCSS, "\n            ").concat(inputState === 'hover' ? "inputStyle_hover ".concat(normalCSS, "_hover") : '', "\n            ").concat(inputState === 'active' ? "inputStyle_focus ".concat(normalCSS, "_focus") : '', "\n            ").concat(disabled ? "inputStyle_disable ".concat(normalCSS, "_disable") : '', "\n          "), onFocus: handleFocus, onBlur: handleBlur, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, onChange: handleChange, onKeyUp: handleKeyUp, onKeyDown: handleKeyDown, autoComplete: "off", readOnly: readOnly }, "".concat(id, "_input")));
};
export default InputBox;
